document.getElementById("cart").addEventListener("change", function (event) {
	if (!event.target || event.target.getAttribute("name") != "numUnits")
		return;
	var params = new URLSearchParams(new FormData(event.target.form));
	cartSet(params.toString());
});

document.getElementById("cart").addEventListener("click", function (event) {
	if (!event.target || event.target.getAttribute("name") != "action" || event.target.getAttribute("value") != "delete")
		return;
	event.preventDefault();
	var params = new URLSearchParams(new FormData(event.target.form));
	cartSet(params.toString() + "&action=delete");
	[].forEach.call(document.getElementsByClassName("cart-summary"), function (element) {
		var xhttp = new XMLHttpRequest();
		xhttp.open("GET", "/cart-summary", false);
		xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		xhttp.send();
		element.innerHTML = xhttp.responseText.trim();
	});
});

function cartSet(postParams) {
	var xhttp = new XMLHttpRequest();
	xhttp.open("POST", "/cart", false);
	xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	xhttp.send(postParams);
	document.getElementById("cart").innerHTML = xhttp.responseText.trim();
}
